module.exports = "/assets/packs/images/407ed96fa0e5a9ece04c9a2fe8e0e83e.png";